import { Component } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PlayerHomeInfo, PlayerInfo } from 'src/data/player-data';
import { PlayerHomeDataService } from 'src/redux/player-home/player-home-data-service';

@Component({
  selector: 'app-tabs',
  templateUrl: 'tabs.page.html',
  styleUrls: ['tabs.page.scss']
})
export class TabsPage {
  public playerHomeInfo$: Observable<PlayerHomeInfo>;
  public player$: Observable<PlayerInfo>;
  public playerPhoto$: Observable<string>;
  constructor(private router: Router, private playerHomeService: PlayerHomeDataService,) {

    // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.player$ = this.playerHomeInfo$.pipe(
    //   filter(Boolean),
    //   map((playerHome: PlayerHomeInfo) => playerHome.player))

    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.ref.detectChanges();
    this.player$ = this.playerHomeInfo$
      .pipe(filter(Boolean)
        , map((playerHome: PlayerHomeInfo) => playerHome.player));
    this.player$.subscribe(res => {
    })

    // this.playerPhoto$ = this.playerHomeService.playerPhoto();
    
    this.playerPhoto$ = this.player$.pipe(map((playerInfo: PlayerInfo) => {
      if (playerInfo.photoUrl) {
        return playerInfo.photoUrl;
      } else if (!playerInfo.photoUrl && playerInfo.thumbnail) {
        return playerInfo.thumbnail;
      } else {
        return '';
      }
    }));
  }

  onHomeClick() {
    this.router.navigate(["/tab3"]);
  }

  onProfileClick() {
    // this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();

    // this.player$ = this.playerHomeInfo$.pipe(
    //   filter(Boolean),
    //   map((playerHome: PlayerHomeInfo) => playerHome.player))



    // this.player$ = this.playerHomeInfo$.pipe(map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player))
    // 
    let params: NavigationExtras = {
      state: {
        type: 'playerProfile',
        // player:this.player$
      },
    };
    this.router.navigate(['tabs/profile'], params);



  }

  updatedColor: number = 0;

  getSVGImageClass(additionalClass: string) {
    if (this.updatedColor > 0)
      return additionalClass + ' ' + 'svg-filter';
    else return additionalClass;
  }
}
